export default function({ store, redirect, query, $paths }) {
  if (process.server) return
  const token = store.getters['user/isLoggedIn']

  if (!token) {
    /** Server logic */
    redirect({
      path: $paths.home,
      query: { ...query, redirected: true },
    })
  }
}
